import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import {
    headers, getPromoCodeDetailsUrl, insertPromoCodeUrl, getPromoCodeListUrl, deletePromoCodeUrl, updatePromoCodeUrl, GET_PROMOCODE_LIST,
    INSERT_PROMOCODE,
    UPDATE_PROMOCODE,
    DELETE_PROMOCODE,
    GET_PROMOCODE_DETAILS
} from "../../../../utils/constants";

export const getPromoCodeDetails_action = (PromoCodeID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            PromoCodeID: PromoCodeID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getPromoCodeDetailsUrl, params, headers)

        dispatch({
            type: GET_PROMOCODE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updatePromoCode_action = (ExihibitionID, AccountTypeID, Discountpercent, ExpiryDate, NoofCoupens, PromoCodeID, Amount) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            AccountTypeID: AccountTypeID,
            Discountpercent: Discountpercent,
            ExpiryDate: ExpiryDate,
            NoofCoupens: NoofCoupens,
            Amount: Amount,
            PromoCodeID: PromoCodeID,

        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updatePromoCodeUrl, params, headers)

        dispatch({
            type: UPDATE_PROMOCODE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getPromoCodeList_action = (CouponCode, disPer, expiry, status) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            CouponCode: CouponCode,
            disPer: disPer,
            expiry: expiry,
            status: 1,

        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getPromoCodeListUrl, params, headers)

        dispatch({
            type: GET_PROMOCODE_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertPromoCode_action = (ExihibitionID, AccountTypeID, Discountpercent, ExpiryDate, NoofCoupens, CouponUtilization, Amount) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            AccountTypeID: AccountTypeID,
            Discountpercent: Discountpercent != '' && Discountpercent != null ? Discountpercent : null,
            ExpiryDate: ExpiryDate,
            NoofCoupens: NoofCoupens,
            CouponUtilization: CouponUtilization,
            Amount: Amount != null && Amount != '' ? Amount : null
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertPromoCodeUrl, params, headers)

        dispatch({
            type: INSERT_PROMOCODE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deletePromoCode_action = (promocodeid) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            promocodeid: promocodeid,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(deletePromoCodeUrl, params, headers)

        dispatch({
            type: DELETE_PROMOCODE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}